import { useEffect } from 'react'

import EditMessageButton from 'Pages/OverviewMessage/EditMessageButton'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import {
  messageState,
  overviewThumbnailState
} from 'Pages/OverviewMessage/recoil/state/message'
import {
  Flex,
  Spinner,
  Thumb,
  ThumbContainer,
  ThumbContainerFooter,
  ThumbDefaultError,
  ThumbDefaultOverlay
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'
import { openBrowserPopup } from 'Helpers/browserPopup'
import { sessionId } from 'mailup-react-helpers'
import { getScreenshotCallback } from '../recoil/callbacks/callbacks'

const BoxThumbnail = () => {
  const { id } = useRecoilValue(messageState)
  const { url, status } = useRecoilValue(overviewThumbnailState)
  const getScreenshot = useRecoilCallback(getScreenshotCallback, [])

  useEffect(() => {
    if (id) {
      getScreenshot()
    }
  }, [id])

  const openPreview = () => {
    status !== 'error' &&
      openBrowserPopup(`/${sessionId}/messages/email/${id}/preview`)
  }

  const onError = () => {
    getScreenshot()
  }

  return (
    <>
      <StyledThumbContainer data-mu-test='overview-message-box-thumbnail'>
        <StyledThumb
          aspectRatio={268 / 321}
          HoverComponent={status !== 'error' ? Overlay : undefined}
          onClick={openPreview}
        >
          {status === 'loaded' && <img src={url} />}
          {status === 'loading' && <Spinner />}
          {status === 'error' && <ContentError onClick={onError} />}
        </StyledThumb>

        <ThumbContainerFooter>
          <Flex padding='10px 30px'>
            <EditMessageButton />
          </Flex>
        </ThumbContainerFooter>
      </StyledThumbContainer>
    </>
  )
}

export default BoxThumbnail

const ContentError = ({ onClick }) => {
  const intl = useIntl()
  return (
    <ThumbDefaultError onClick={onClick}>
      {intl.formatMessage({ id: 'Load.MailupCommon.PreviewRefresh' })}
    </ThumbDefaultError>
  )
}

ContentError.propTypes = {
  onClick: PropTypes.func.isRequired
}

const Overlay = () => {
  const intl = useIntl()

  return (
    <ThumbDefaultOverlay>
      {intl.formatMessage({ id: 'Load.MailupCommon.PreviewOpen' })}
    </ThumbDefaultOverlay>
  )
}

const StyledThumbContainer = styled(ThumbContainer)`
  overflow: visible !important;
`

const StyledThumb = styled(Thumb)`
  border-radius: 6px 6px 0 0;
  overflow: hidden;
`
